// ============================================================================
// rep-mode.js — is this the PORTAL copy of the designer, and who is driving it?
// ============================================================================
// The same bundle serves two audiences. On /pages/weight-designer it is the buyer's
// tool. On the portal's /pages/rep-weight-designer it is a rep's tool, and three
// things have to change:
//
//   1. A design sheet (PDF) can be generated — the portal page owns the button, this
//      module owns the answer to "am I allowed to offer it".
//   2. A share link must point at the PUBLIC page, never at the portal page the rep
//      is standing on. Otherwise "Copy link" mails a committee a URL that demands a
//      portal login.
//   3. Funnel events stop firing. A rep clicking through the tool is not a buyer, and
//      the six daily counters exist to answer "where do buyers stop".
//
// The handshake is a global set by the Liquid section BEFORE this bundle loads
// (sections/rep-quote-weight-designer.liquid), mirroring the Gym Layout Designer's
// `window.__rdPortalMode`. A query param is honoured too, which is what makes the
// mode testable on the dev server where there is no portal page.
//
// NOT a permission check. The rep gate is the portal page itself; this module only
// answers "which of the two skins am I wearing". Nothing here should ever be the
// thing standing between a person and data.
// ============================================================================

let _cachedMode = null;

/** True when the designer is running as the portal/rep edition. */
export function isRepMode() {
  if (_cachedMode !== null) return _cachedMode;
  let on = false;
  try {
    on = window.__wdPortalMode === true
      || new URLSearchParams(location.search).get('rep') === '1';
  } catch { on = false; }
  _cachedMode = on;
  return on;
}

/**
 * The signed-in rep, as the portal page handed it over: { name, email, phone, code }.
 * Always an object so callers can spread it without guarding. Empty off the portal.
 *
 * Read live rather than cached — the portal writes it after its auth gate resolves,
 * which can land after this bundle has booted.
 */
export function getRep() {
  try {
    const r = window.__wdRep;
    if (!r || typeof r !== 'object') return {};
    return {
      name: String(r.name || ''),
      email: String(r.email || ''),
      phone: String(r.phone || ''),
      code: String(r.code || ''),
    };
  } catch {
    return {};
  }
}

/**
 * Where a shareable link to a design should point — ALWAYS the public tool page.
 * On the portal that is a different path from the one we are on; everywhere else it
 * is the page we are already on, so this is a no-op for the buyer's copy.
 */
export const PUBLIC_TOOL_PATH = '/pages/weight-designer';
